var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "disflex w60p" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  return _vm.createAdmin()
                }
              }
            },
            [_vm._v("添加账号")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "mt10",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "", label: "用户名", prop: "name", width: "150" }
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: "中文名",
              prop: "nameInChinese",
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "电话", prop: "mobile", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { label: "邮箱", prop: "email", width: "180" }
          }),
          _c("el-table-column", {
            attrs: { label: "角色类型", prop: "roleName", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.roleId == 1
                      ? _c("span", [_vm._v("超级管理员")])
                      : _vm._e(),
                    scope.row.roleId == 2
                      ? _c("span", [_vm._v("管理员")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "status", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.status == "active"
                      ? _c("span", [_vm._v("启用")])
                      : _vm._e(),
                    scope.row.status == "forbidden"
                      ? _c("span", [_vm._v("禁用")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        staticClass: "m10 cp",
                        on: {
                          click: function($event) {
                            return _vm.handelAct(scope.$index, -1)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-tag",
                      {
                        staticClass: "m10 cp",
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.handelAct(scope.$index, -2)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "mt10",
        attrs: {
          "current-page": _vm.page,
          "page-size": 10,
          layout: "total, prev, pager, next",
          total: _vm.totalNumber
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function($event) {
            _vm.page = $event
          },
          "update:current-page": function($event) {
            _vm.page = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }